import type { SvgComponent } from '@/types/SvgComponent';

export const MusicNoteIcon: SvgComponent = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2663_7243)">
        <path
          d="M29.5312 31.5C32.0683 31.5 34.125 29.4433 34.125 26.9062C34.125 24.3692 32.0683 22.3125 29.5312 22.3125C26.9942 22.3125 24.9375 24.3692 24.9375 26.9062C24.9375 29.4433 26.9942 31.5 29.5312 31.5Z"
          stroke="white"
          strokeWidth="1.96875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.53125 36.75C11.0683 36.75 13.125 34.6933 13.125 32.1562C13.125 29.6192 11.0683 27.5625 8.53125 27.5625C5.99419 27.5625 3.9375 29.6192 3.9375 32.1562C3.9375 34.6933 5.99419 36.75 8.53125 36.75Z"
          stroke="white"
          strokeWidth="1.96875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.125 11.8125L13.125 17.0625"
          stroke="white"
          strokeWidth="1.96875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.125 32.1562V9.1875L34.125 3.9375V26.9062"
          stroke="white"
          strokeWidth="1.96875"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2663_7243">
          <rect width="42" height="42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
